import { thunk } from 'redux-thunk';
import { IApplicationState } from './models/ApplicationState';
import {
    combineReducers,
    createStore,
    compose,
    applyMiddleware,
} from 'redux';
import { reducers } from './reducers';

export default function configureStore(initialState?: IApplicationState) {
    const rootReducer = combineReducers({
        ...reducers,
    });

    const windowIfDefined = typeof window === 'undefined' ?
        null :
        (window as any);

    const composeEnhancers: typeof compose =
        windowIfDefined?.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?? compose;

    return createStore(
        rootReducer,
        initialState,
        composeEnhancers(applyMiddleware(thunk)));
}
